import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'formatMap',
})
export class FormatMapErrorPipe implements PipeTransform {

  static readonly PREFIX = 'maps.exception.';
  static readonly _errorPageTitle = "errorPageTitle";

  constructor(private translateService: TranslateService) {
  }

  transform(error): string {
    if (!error || !error.mapSystem) {
      return null;
    }
    const translatedMapSystem = this.translateService.instant(error.mapSystem);
    let out = this.translateService.instant(FormatMapErrorPipe.PREFIX + FormatMapErrorPipe._errorPageTitle, {fremdsystem: translatedMapSystem});
    if (error.exceptionName) {
      out += ' ' + this.translateService.instant(FormatMapErrorPipe.PREFIX + error.mapSystem.toLowerCase() + '.' + error.exceptionName);
      if (error.errorCode) {
        out += ' (' + error.errorCode + ')';
      }
    }
    return out;
  }
}
